import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Help from "./Help";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

export default function HelpDrawer() {
  const { t, i18n } = useTranslation();
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 400,
        position: "relative",
        overflow: "hidden",
      }}
      role="presentation"
    >
      <Box
        sx={{
          pl: 3,
          pt: 5,
          fontWeight: "bold",
          fontSize: "28px",
          pb: 1,
        }}
      >
        {t("Help2")}
      </Box>
      <Divider sx={{ pt: 1, pb: 1 }} />
      <Help />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          px: 2,
          position: "absolute",
          bottom: 0,
          zIndex: 1000,
          width: 1,
          backgroundColor: "white",
          boxSizing: "border-box",
          pb: 2,
        }}
      >
        <HashLink to="/faq#top">
          <button className="custom_btn_whitebg">{t("View all help")}</button>
        </HashLink>
        <HashLink to="/contact#top">
          <button className="custom_btn_whitebg" style={{ marginTop: "4px" }}>
            {t("Contact Customer Service")}
          </button>
        </HashLink>
      </Box>
    </Box>
  );

  return (
    <div>
      {["Help"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)}>{t(anchor)}</Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
